<template>
  <div
    :class="{
      printq_matrix_app: 1,
      highIndex: hasActivePageOption && getIsLfp
    }"
  >
    <div v-if="hasActivePageOption && getIsLfp" class="overlayLfp"></div>
    <div v-if="getMatrixConfiguration" v-html="getMatrixConfiguration"></div>
    <component :is="getTransitionUsedElement" name="fade">
      <component
        :is="getLayout"
        v-if="!getIsLoading && !getNetworkError"
        :class="isMobileClass"
      ></component>
    </component>
    <div v-if="!getIsLoading" class="matrix_portalContainer">
      <Teleport
        v-for="(item, index) in getPortalElements"
        :key="index"
        :to="item.id"
        class="matrix_portalElements"
      >
        <component :is="item.type"></component>
      </Teleport>
    </div>
    <appHiddenInputFields
      v-if="!getNetworkError && !getIsLoading"
    ></appHiddenInputFields>
    <appHiddenInputFieldsWithIds
      v-if="!getNetworkError && !getIsLoading"
    ></appHiddenInputFieldsWithIds>
    <appLoading v-show="getShowLoading" :initialLoading="getIsLoading" />
    <appNetworkError v-if="getNetworkError" />
  </div>
</template>

<script>
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useConfigStore } from "@/stores/modules/config";
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { usePersonalizeStore } from "@/stores/modules/personalize";
import { useMyAccountStore } from "@/stores/modules/myAccount";
import { usePreview3DStore } from "@/stores/modules/preview3D";
import { usePackingOptionsStore } from "@/stores/modules/packingOptions";
import { useBundleStore } from "@/stores/modules/bundle";
import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { useActiveOptionStore } from "@/stores/modules/activeOption";

import { mapState, mapActions } from "pinia";
import { callbackService } from "./helpers/callbackService";
import { v4 as uuidv4 } from "uuid";
import { getLayoutName, getMyAccountLayoutName } from "../src/layouts";
import { defineAsyncComponent } from "vue";

//import $ from "jquery";
//window.jQuery = window.$ = $;
//window.jQuery = $;

//version 0.5.0

export default {
  name: "App",
  components: {
    appLayoutImageEditor: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: "lfp" */ "./external_components/LayoutImageEditor.vue"
        )
    )
  },
  props: {
    appProps: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    ...mapState(useWebproductStore, [
      "getIsLoading",
      "getLayoutType",
      "getNetworkError",
      "getSelector",
      "getSelectionId",
      "getMatrixConfiguration",
      "getIsMobile",
      "getTransitionUsedElement",
      "getIsLfp",
      "getHideInitialLoading"
    ]),
    ...mapState(useChangeOptionsStore, ["getShowChangeOptionsLoader"]),
    ...mapState(useActiveOptionStore, ["getActivePageOption"]),
    ...mapState(usePersonalizeStore, ["getPersonalizeLoading"]),
    ...mapState(useMyAccountStore, ["getIsMyAccount"]),
    ...mapState(usePreview3DStore, ["getPreview3DLoading"]),
    hasActivePageOption: function () {
      return this.getActivePageOption != "";
    },
    getShowLoading: function () {
      return (
        !this.getHideInitialLoading &&
        !this.getNetworkError &&
        (this.getIsLoading ||
          this.getShowChangeOptionsLoader ||
          this.getPersonalizeLoading ||
          this.getPreview3DLoading)
      );
    },
    getPortalElements: function () {
      return this.appProps.portalComponents;
    },
    getLayout: function () {
      if (this.getIsMyAccount) {
        return getMyAccountLayoutName();
      }
      return getLayoutName(this.getLayoutType);
    }
  },
  methods: {
    ...mapActions(useWebproductStore, [
      "setIsLoading",
      "loadInitialData",
      "setIsMobile",
      "closeFancybox"
    ]),
    ...mapActions(usePackingOptionsStore, ["setMainWindow"]),
    ...mapActions(usePersonalizeStore, ["setCustomizedProductId"]),
    ...mapActions(useConfigStore, ["onScrollEvent", "onScrollEventPosition"]),
    setPersonalizationStatusCallback: function (event) {
      if (
        event &&
        event.data &&
        event.data.type == "pqMatrix_personalization_event"
      ) {
        callbackService.sendCallback(
          callbackService.callbacks.afterPersonalizationCallback,
          event.data
        );

        if (event.data.success) {
          this.setCustomizedProductId(event.data);
          this.closeFancybox();
        } else {
          window.location.href = event.data.redirect_url;
        }
      }
    },
    handleScroll(event) {
      this.onScrollEvent(event);
    }
  },
  data: function () {
    return {
      vers: process.env.VUE_APP_VERSION,
      isMobileClass: window.innerWidth <= 990 ? "matrix_layoutMainMobile" : ""
    };
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  created() {
    window.printqMatrixVersion = process.env.VUE_APP_VERSION;
    window.lfpGlobalStore = useImageEditorStore();

    this.setIsMobile(window.innerWidth <= 990);

    if (!String.prototype.rtrim) {
      String.prototype.rtrim = function (s) {
        if (s == undefined) s = "\\s";
        return this.replace(new RegExp("[" + s + "]*$"), "");
      };
    }

    if (!String.prototype.ltrim) {
      String.prototype.ltrim = function (s) {
        if (s == undefined) s = "\\s";
        return this.replace(new RegExp("^[" + s + "]*"), "");
      };
    }

    if (!String.prototype.replaceAll) {
      String.prototype.replaceAll = function (search, replacement) {
        var target = this;
        return target.split(search).join(replacement);
      };
    }
    if (!String.prototype.insert) {
      String.prototype.insert = function (index, string) {
        if (index > 0)
          return (
            this.substring(0, index) +
            string +
            this.substring(index, this.length)
          );
        else return string + this;
      };
    }

    addEventListener("resize", () => {
      this.setIsMobile(window.innerWidth <= 990);
      this.isMobileClass =
        window.innerWidth <= 990 ? "matrix_layoutMainMobile" : "";
    });

    window.addEventListener("scroll", this.handleScroll);

    window.addEventListener("message", this.setPersonalizationStatusCallback);

    this.setIsLoading(true);
    this.setMainWindow(this);
    this.loadInitialData({
      webProductId: this.appProps.webProductId,
      webProductSku: this.appProps.webProductSku,
      customer: this.appProps.customer || uuidv4(),
      selectionId: this.appProps.selectionId,
      initialConfig: this.appProps.initialConfig,
      getConfigTokenData: this.appProps.getConfigTokenData,
      base_url: this.appProps.base_url,
      urls: this.appProps.urls,
      isMyAccount: this.appProps.isMyAccount,
      myAccountSelection: this.appProps.myAccountSelection,
      myAccountUploadPath: this.appProps.myAccountUploadPath,
      myAccountUploadedFiles: this.appProps.myAccountUploadedFiles,
      theme: this.appProps.theme,
      selector: this.appProps.selector,
      config: this.appProps.config
    });
  }
};
</script>
